import { mdiTrashCanOutline, mdiWaterPump } from '@mdi/js'
import Icon from '@mdi/react'
import { Box, Tooltip } from '@mui/material'
import { FC } from 'react'

import type { EventMarker, EventProgress } from '../../data/source'
import { EVENT_DONE_COLOR } from '../../theme'

/** The colors bombeo-app's scale list uses for BOMBEO progress; also the Gantt bars'. */
export const PROGRESS_COLORS: Record<EventProgress, string> = {
  NOT_STARTED: '#9CA3AF',
  IN_PROGRESS: '#2563EB',
  DONE: EVENT_DONE_COLOR,
}

export interface EventMarkerIconProps {
  marker: EventMarker
  /** What the circle stands for, e.g. "32C" or "MARPOL I #2": its tooltip and accessible name. */
  label: string
  size?: number
  /** False where something around the circle already has a tooltip. */
  tooltip?: boolean
}

/**
 * One event of a scale on a circle colored by its progress: a berth stay shows
 * its muelle, a MARPOL a bin, a BOMBEO a pump.
 */
export const EventMarkerIcon: FC<EventMarkerIconProps> = ({ marker, label, size = 24, tooltip = true }) => {
  const circle = (
    <Box
      data-testid={`event-marker-${marker.id}`}
      role="img"
      aria-label={label}
      sx={{
        width: size + 8,
        height: size + 8,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        bgcolor: PROGRESS_COLORS[marker.progress],
        color: '#ffffff',
        fontSize: size * 0.45,
        fontWeight: 'bold',
        lineHeight: 1,
      }}
    >
      {marker.muelle ?? (
        <Icon path={marker.type === 'MARPOL' ? mdiTrashCanOutline : mdiWaterPump} size={`${String(size - 6)}px`} color="#ffffff" />
      )}
    </Box>
  )
  return tooltip ? <Tooltip title={label}>{circle}</Tooltip> : circle
}
